import "./ClassicyIcon.scss";
import classNames from "classnames";
import React, { useRef, useState } from "react";

interface ClassicyIconProps {
  appId: string;
  name: string;
  icon: string;
  label?: string;
  position?: [number, number];
  size?: number; // Icon size in pixels (default: 64)
  fontSize?: number;
  onClickFunc?: any;
  invisible?: boolean;
}

export const ClassicyIcon: React.FC<ClassicyIconProps> = ({
  appId,
  name,
  icon,
  label,
  position = [0, 0],
  size = 64,
  fontSize = 24,
  onClickFunc,
  invisible = false,
}) => {
  const [active, setActive] = useState<boolean>(false);

  const iconRef = useRef<HTMLDivElement>(null);

  const id = appId + ".shortcut";

  const handleClick = () => {
    if (onClickFunc) {
      setActive(true);
      // Brief visual feedback before executing action
      setTimeout(() => {
        setActive(false);
        onClickFunc();
      }, 150);
    }
  };

  return (
    <div
      ref={iconRef}
      id={`${id}-${Math.random().toString(36).substring(2, 7)}`}
      draggable={false}
      className={classNames("classicyIcon", active ? "classicyIconActive" : "")}
      style={{
        position: "absolute",
        left: position[0] + "px",
        top: position[1] + "px",
        cursor: "pointer",
        // Pass size as CSS custom property
        ["--icon-size" as any]: `${size}px`,
        ["--icon-font-size" as any]: `${fontSize}px`,
      }}
      onClick={handleClick}
    >
      <div
        className={classNames(
          "classicyIconMaskOuter",
          invisible ? "classicyIconInvisible" : "",
        )}
        style={{ maskImage: `url(${icon})` }}
      >
        <div className={"classicyIconMask"} style={{ mask: `url(${icon})` }}>
          <img src={icon} alt={name} />
        </div>
      </div>
      <p className={classNames(invisible ? "classicyIconInvisible" : "")}>
        {label ? label : name}
      </p>
    </div>
  );
};
